const SCRAPED_ITEM_SELECTION_SOURCES = {
  SCRAPING_DEBUG_TREE_SELECT: 'SCRAPING_DEBUG_TREE_SELECT',
  SCRAPING_DEBUG_GALLERY: 'SCRAPING_DEBUG_GALLERY',
}

export default SCRAPED_ITEM_SELECTION_SOURCES
